module.exports = __webpack_public_path__ + "static/img/school2.cd42ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school2.png
// module id = rzjv
// module chunks = 1